import { ReactElement, useState } from "react"

import * as api from "./api"
import "./index.scss"

interface UserGroup {
  name: string
  guid: string
}

const OwnedGroups = (props: { ownedGroupsInitial: UserGroup[] }): ReactElement | null => {
  const [ownedGroups, setOwnedGroups] = useState(props.ownedGroupsInitial)

  const deleteGroup = async (group: UserGroup) => {
    if (window.confirm(`Are you sure you want to delete "${group.name}"?`)) {
      const {userGroupDelete: { errors } } = await api.deleteGroup(group.guid)
      if (errors.length === 0) {
        setOwnedGroups(ownedGroups.filter((g: UserGroup) => g.guid !== group.guid))
      } else {
        window.appendFlash(`${group.name} could not be deleted.`)
      }
    }
  }

  return (
    <ul>
      {ownedGroups.map((group) => (
        <li>
          <a className="link-inline">{group.name}</a>
          <a onClick={() => deleteGroup(group)} className="link-inline">Delete group</a>
        </li>
      ))}
    </ul>
  )
}

interface Props {
  ownedGroups: UserGroup[]
  memberGroups: UserGroup[]
  pendingGroups: UserGroup[]
}

const UserGroups = (props: Props): ReactElement | null => {
  const [memberGroups, setMemberGroups] = useState(props.memberGroups)
  const [pendingGroups, setPendingGroups] = useState(props.pendingGroups)

  return (
    <div styleName="container">
      <header>
        <h2>Your groups</h2>
        <button className="button-tertiary">New group</button>
      </header>

      <OwnedGroups ownedGroupsInitial={props.ownedGroups} />

      {[...memberGroups, ...pendingGroups].length ? (
        <>
          <h2>Other groups</h2>

          <ul>
            {memberGroups.map((group) => (
              <li>
                <div>{group.name}</div>
                <a className="link-inline">Leave group</a>
              </li>
            ))}

            {pendingGroups.map((group) => (
              <li>
                <div>{group.name}</div>
                <div styleName="pending-options">
                  <a className="link-inline">Accept</a>
                  <a className="link-inline">Decline</a>
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : null
      }
    </div>
  )
}

export default UserGroups
